/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ConsoleLogProvider", ["LogProviderBase"], function (context, cls) {
  /**
   * @class ConsoleLogProvider
   * @memberOf classes
   * @extends classes.LogProviderBase
   */
  class ConsoleLogProvider extends cls.LogProviderBase /** @lends classes.ConsoleLogProvider.prototype */ {
    getLogger() {
      return window.console;
    }
  }

  cls.ConsoleLogProvider = ConsoleLogProvider;
});
